/**
 * This class will define the Navigation items.
 * <P>The object is to separate the data with view.
 */
import {Injectable} from '@angular/core';

export interface NavItem {
  id: string;
  name: string;
  icon?: string;  // current support the mat-icon name
  sectionName?: string;
  examples?: string[];
  title?: string;
}

export interface NavCategory {
  id: string;
  name: string;
  items: NavItem[];
  summary?: string;
}

// display the header nav by using the SECTION
const HOME = 'home';
const STUDY = 'study';
const BLOG = 'blog';
export const SECTIONS = {
  [HOME]: 'NAVBAR.HOME',
  [STUDY]: 'NAVBAR.STUDY',
  [BLOG]: 'NAVBAR.BLOG',
};

// define the overall navigation structure
const NAVS: {[key: string]: NavCategory[]} = {
  [HOME]: [
    {
      id: 'new_tech',
      name: 'New Tech',
      items: [
        {id: 'mobx', name: 'mobx', icon: 'face', title: 'Mobx Study'},
        {id: 'it2', name: 'it2', icon: 'favorite'}
      ]
    },
    {
      id: 'pro_angular_2nd',
      name: 'Pro Angular 2nd', // the study of pro angular 2nd book
      items: [
        {id: 'form_validation', name: 'Form Validation', icon: 'check_circle'},
        {id: 'router', name: 'Router', icon: 'directions'},
        {id: 'it2', name: 'it2', icon: 'favorite'}
      ]
    },
  ],
  [STUDY]: [
    {
      id: 'test1',
      name: 'test1_name',
      items: [
        {id: 'it1', name: 'it1'},
        {id: 'it2', name: 'it2'}
      ]
    },
    {
      id: 'test2',
      name: 'test2_name',
      items: [
        {id: 'it1', name: 'it1'},
        {id: 'it2', name: 'it2'}
      ]
    }
  ],
  [BLOG]: [
    {
      id: 'test1',
      name: 'test1_name',
      items: [
        {id: 'it1', name: 'it1'},
        {id: 'it2', name: 'it2'}
      ]
    },
    {
      id: 'test2',
      name: 'test2_name',
      items: [
        {id: 'it1', name: 'it1'},
        {id: 'it2', name: 'it2'}
      ]
    }
  ]
};

for (const category of NAVS[HOME]) {
  for (const item of category.items) {
    item.sectionName = HOME;
  }
}

for (const category of NAVS[STUDY]) {
  for (const item of category.items) {
    item.sectionName = STUDY;
  }
}

for (const category of NAVS[BLOG]) {
  for (const item of category.items) {
    item.sectionName = BLOG;
  }
}

const ALL_HOME = NAVS[HOME].reduce(
  (result, category) => result.concat(category.items), []);
const ALL_ABOUT = NAVS[BLOG].reduce((result, blog) => result.concat(blog.items), []);
const ALL_ITEMS = ALL_HOME.concat(ALL_ABOUT);
const ALL_CATEGORIES = NAVS[HOME].concat(NAVS[BLOG]);

@Injectable()
export class NavItems {
  getCategories(section: string): NavCategory[] {
    return NAVS[section];
  }

  getItems(section: string): NavItem[] {
    if (section === HOME) {
      return ALL_HOME;
    }
    if (section === BLOG) {
      return ALL_ABOUT;
    }
    return [];
  }

  getItemById(id: string, section: string): NavItem {
    // the setion should be in the SECTION list.
    const sectionLookup = section === HOME ? HOME : BLOG;
    return ALL_ITEMS.find(item => item.id === id && item.sectionName === sectionLookup);
  }

  getCategoryById(id: string): NavCategory {
    return ALL_CATEGORIES.find(c => c.id === id);
  }
}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/nav-items/nav-items.ts